module.exports = __webpack_public_path__ + "static/media/taskimage.ff258b3c.jpg";